import log from 'core/libs/logger';

function getStepType(step) {
  if (step.videotutorial) return 'videotutorial';
  if (step.quiz) return 'quiz';
  if (step.codechallenge) return 'codechallenge';
  if (step.note) return 'note';
  if (step.project) return 'project';

  log('This step has no type ???', {
    step,
    currentUrl: typeof window !== 'undefined' && window.location.href,
  });
  return 'videotutorial';
}

export default getStepType;
